import {
  apiClient,
} from "./apiClient";

import type {
  UserOrdersData,
  UserOrdersQuery,
} from "../types/orders.types";

function buildUserOrdersQuery(
  query: UserOrdersQuery = {},
) {
  const params =
    new URLSearchParams();

  if (query.status) {
    params.set(
      "status",
      query.status,
    );
  }

  if (query.paymentStatus) {
    params.set(
      "paymentStatus",
      query.paymentStatus,
    );
  }

  if (query.search?.trim()) {
    params.set(
      "search",
      query.search.trim(),
    );
  }

  if (query.sort) {
    params.set(
      "sort",
      query.sort,
    );
  }

  if (
    query.limit !== undefined
  ) {
    params.set(
      "limit",
      String(query.limit),
    );
  }

  if (query.cursor?.trim()) {
    params.set(
      "cursor",
      query.cursor.trim(),
    );
  }

  const queryString =
    params.toString();

  return queryString
    ? `?${queryString}`
    : "";
}

export const ordersApi = {
  getUserOrders(
    uid: string,
    query: UserOrdersQuery = {},
  ) {
    return apiClient.get<UserOrdersData>(
      `/users/${encodeURIComponent(
        uid,
      )}/orders${buildUserOrdersQuery(
        query,
      )}`,
    );
  },
};